import styled from 'styled-components';
import Text from '@/styles/Themes/Text';
import Screen from '@/styles/Themes/Screen';
import { FlexPresets } from '@/styles/Themes/Presets';
import { Palette } from '@/styles/Themes/Palette';
import { WhiteCross } from '@/shared/images/icons/WhiteCross';
import { radius } from '@/styles/Themes/Metrics';
import { cssVars } from '@/styles/Themes/cssVars';

export const CounterWrapper = styled.div.attrs(({ isCart }: { isCart: boolean }) => ({ isCart }))`
    width: ${({ isCart }) => (isCart ? '100%' : '100vw')};
    min-height: ${({ isCart }) => (isCart ? '238px' : 0)};
    padding: ${({ isCart }) => (isCart ? '0' : 0)};

    ${Screen.ipad} {
        min-height: ${({ isCart }) => (isCart ? '232px' : 0)};
    }
`;

export const CounterText = styled.div`
    color: ${cssVars.fg_gray2_gray3};
    display: flex;
    justify-content: center;
    ${Text.Full.large.semibold};
    padding: 132px 6px 0;
`;

export const Description = styled.p`
    color: ${cssVars.fg_gray2_gray3};
    display: flex;
    justify-content: center;
    ${Text.Full.medium.regular};
    margin: 0 0 16px;
    padding: 0 20px;
    text-align: center;

    ${Screen.ipad} {
        padding: 0 60px;
    }

    ${Screen.desktop} {
        margin: 0;
    }
`;

export const CounterLine = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 20px;

    ${Screen.ipad} {
        padding: 0 60px;
    }
`;

export const Counter = styled.div`
    color: ${cssVars.fg_gray1_white};
    ${Text.Full.heading2};
    background-color: ${cssVars.bg_ash_dark2};
    margin: 12px 0 4px;
    width: 100%;
    max-width: 680px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 16px;
    border-radius: ${radius.small};
    position: relative;
    overflow: hidden;

    ${Screen.ipad} {
        margin: 16px auto 4px;
    }

    ${Screen.desktop} {
        margin: 16px auto 4px;
    }
`;

export const CounterBlock = styled.p`
    min-width: 28px;
    margin: 0;
    text-align: center;

    ${Screen.ipad} {
        min-width: 36px;
    }

    ${Screen.desktop} {
        min-width: 32px;
    }
`;

export const CounterDescription = styled.p`
    margin: 0;
    ${Text.Full.normal.regular};
`;

export const ProgressBar = styled.div`
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 2px;
    background-color: ${cssVars.bg_gray4_dark1};
`;

export const ProgressLine = styled.div<{ width: number }>`
    width: ${({ width }) => width + '%'};
    height: 100%;
    background-color: ${Palette.green.normal};
`;

export const ButtonWrapper = styled.div`
    ${FlexPresets.flexRowCenter};
    width: 270px;
    height: 36px;
    cursor: pointer;
    margin: 24px auto 6px;
    ${Text.Mobile.medium.medium};

    ${Screen.desktop} {
        ${Text.Desktop.large.medium};
    }
`;

export const IconWhiteCross = styled(WhiteCross)`
    height: 8px;
    width: 9px;

    ${Screen.desktop} {
        height: 8px;
        width: 7px;
    }
`;

export const ExtendMinutes = styled.div`
    margin: 0 10px;
`;
